function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCalendarAddCalendarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 5h-3V3h-2v2H10V3H8v2H5a2 2 0 00-2 2v7h26V7a2 2 0 00-2-2zm0 7H5V7h3v3h2V7h12v3h2V7h3v5z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.494 27H5V16H3v11a2 2 0 002 2h11.494v-2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20v-2H8v2h4zM12 22v2H8v-2h4zM18.032 20v-2h-4v2h4zM16.032 22v2h-2v-2h2zM23 30V18h2v12h-2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 25H18v-2h12v2z",
    fill: props.color
  }));
}

export default SvgIconCalendarAddCalendarFilled;